import HeroBanner from "@/components/hero-banner";
import React from "react";
import { useTranslation } from "react-i18next";

export default function TermsAndConditionsPage() {
  const bullets = [
    "Appointments are non-refundable.",
    "Appointments cannot be transferred to another person.",
    "The appointment is valid only for the specific service you have booked.",
    "You may only book Three service per appointment.",
    "A valid ID must be presented at the time of the appointment.",
    "You must arrive on time for your appointment.",
    "If you are late, we reserve the right not to serve you.",
  ];

  const {t} = useTranslation();

  return (
    <div className="flex justify-center pb-12">
      <div className="w-full max-w-md px-4">
        <div className="bg-white rounded-2xl shadow-md p-6">
          <h1 className="text-center font-semibold text-lg text-slate-800 mb-4">
            {t("Appointment Policy Consent")}
          </h1>

          <ul className="space-y-3 text-sm text-gray-600">
            {bullets.map((b, i) => (
              <li key={i} className="flex gap-3 items-start">
                <span className="mt-1 inline-block w-2 h-2 rounded-full bg-slate-400/70 flex-shrink-0" />
                <span className="leading-tight">{t(b)}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-6">
          <HeroBanner />
        </div>
      </div>
    </div>
  );
}
